import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID, simpleSort } from "@miplatform/utils";

export const useAddAddersViewModel = ({ onContinue, reset }) => {
  const [adderDetails, setAdderDetails] = useState({});

  const stateManager = useComponentState();
  const GET_ADDER_DETAILS_UUID = createUUID();
  const HANDLE_CREATE_ADDER_UUID = createUUID();
  const HANDLE_UPDATE_ADDER_UUID = createUUID();

  const handleCreateAdder = (data) => {
    stateManager.abort(HANDLE_CREATE_ADDER_UUID);
    return stateManager.run(async () => {
      const response = await homeService.adders.create({
        data,
        toastMessageConfig: {
          success: {
            text: `Successfully created ${data.name}.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.CREATED) {
        getAdderDetails(response.data.id);
        onContinue(response.data.id);
        return response.data;
      }
      return null;
    }, HANDLE_CREATE_ADDER_UUID);
  };

  const handleUpdateAdder = async (data) => {
    stateManager.abort(HANDLE_UPDATE_ADDER_UUID);
    return stateManager.run(async () => {
      const response = await homeService.adders.update({
        id: data.id,
        data,
        toastMessageConfig: {
          success: {
            text: `Successfully updated ${data.name}.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        getAdderDetails(response.data.id);
        onContinue(response.data.id);
        return response.data;
      }
      return null;
    }, HANDLE_UPDATE_ADDER_UUID);
  };

  const getAdderDetails = (id) => {
    stateManager.abort(GET_ADDER_DETAILS_UUID);
    stateManager.run(async () => {
      const response = await homeService.adders.getById({ id });
      if (response.status === HTTP_STATUSES.OK) {
        response.data.materials.sort((a, b) =>
          simpleSort(a.category?.itemCode, b.category?.itemCode)
        );
        setAdderDetails(response.data);
        reset(response.data);
      }
    }, GET_ADDER_DETAILS_UUID);
  };

  return {
    stateManager,
    isLoading: stateManager.isBusy(),
    adderDetails,
    getAdderDetails,
    handleCreateAdder,
    handleUpdateAdder,
  };
};
